export default {
  en: "Anglais",
  fr: "Français",
  es: "Espagnol",
  de: "Allemand",
  it: "Italien",
  pt: "Portugais",
  ru: "Russe",
  zh: "Chinois",
  ja: "Japonais",
  ko: "Coréen",
  ar: "Arabe",
  hi: "Hindi",
  tr: "Turc",
  nl: "Néerlandais",
  pl: "Polonais",
  sv: "Suédois",
  da: "Danois",
  fi: "Finnois",
  no: "Norvégien",
  cs: "Tchèque",
  hu: "Hongrois",
  ro: "Roumain",
  bg: "Bulgare",
  el: "Grec",
  he: "Hébreu",
  th: "Thaïlandais",
  vi: "Vietnamien",
  id: "Indonésien",
  ms: "Malais",
  fa: "Persan"
};

